// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MIlPz","comment":"styles_comment__22q-E"};